function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export function createMapScript(options) {
  var googleMapScript = document.createElement('SCRIPT');

  if (_typeof(options) !== 'object') {
    throw new Error('options should  be an object');
  } // libraries

  /* eslint-disable no-prototype-builtins */


  if (Array.prototype.isPrototypeOf(options.libraries)) {
    options.libraries = options.libraries.join(',');
  }

  options['callback'] = 'vueGoogleMapsInit';
  var baseUrl = 'https://maps.googleapis.com/maps/api/js?';
  var url = baseUrl + Object.keys(options).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
  }).join('&');
  googleMapScript.setAttribute('src', url);
  googleMapScript.setAttribute('async', '');
  googleMapScript.setAttribute('defer', '');
  return googleMapScript;
}